"use client";
import React, { Fragment } from "react";
import {
  LightIcon,
  LightIconDark,
  UserSquareIcon,
  UserSquareIconDark,
} from "../../components/common/Icons";
import { useTranslations } from "next-intl";

const AboutSections = () => {
  const t = useTranslations("AboutPage");

  return (
    <Fragment>
      {/* Hero Section */}
      <div
        className="bg-cover bg-center bg-background-styling"
        id="hero-section"
      >
        <div className="container">
          <div className="flex flex-col lg:flex-row py-10 lg:py-32 gap-y-6 lg:gap-y-0 gap-x-16">
            <div className="basis-1/2 flex flex-col gap-y-6 lg:gap-y-10 justify-center">
              <h2 className="text-2xl lg:text-4xl text-center lg:text-left">
                {t("hero.title")}
              </h2>
              <p className="text-center lg:text-left text-lg lg:text-2xl opacity-80">
                {t("hero.description")}
              </p>
            </div>

            <div className="basis-1/2 flex flex-col justify-center items-center">
              <div className="h-[310px] lg:h-[420px] w-full mx-auto px-4 shadow-about-card bg-center rounded-2xl object-cover bg-no-repeat bg-[url('/assets/v2/images/about-page-1.png')] bg-cover"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 */}
      <div className="container">
        <div className="flex flex-col lg:flex-row py-10 lg:py-32 gap-y-6 lg:gap-y-0 gap-x-16">
          <div className="order-last lg:order-first basis-1/2 flex flex-col items-center">
            <div className="h-[310px] lg:h-[420px] w-full mx-auto px-4 shadow-about-card bg-center rounded-2xl object-cover bg-no-repeat bg-[url('/assets/v2/images/about-page-2.png')] bg-cover"></div>
          </div>
          <div className="basis-1/2 flex flex-col gap-y-6 lg:gap-10 justify-center">
            <h2 className="text-2xl lg:text-4xl text-center lg:text-left">
              {t("section2.title")}
            </h2>
            <p className="text-center lg:text-left text-lg lg:text-2xl opacity-80">
              {t("section2.description")}
            </p>
          </div>
        </div>
      </div>

      {/* Section 3 */}
      <div className="container">
        <div className="py-6 lg:py-16 flex flex-col lg:flex-row gap-6">
          {/* Left Card */}
          <div className="basis-1/2">
            <div className="bg-white shadow dark:bg-zinc-900 rounded-2xl p-10 flex flex-col gap-6 lg:h-[692px] xl:h-[528px] 2xl:h-[472px]">
              <div className="dark:block hidden">
                <LightIcon />
              </div>
              <div className="dark:hidden block">
                <LightIconDark />
              </div>
              <h5 className="text-2xl lg:text-4xl">
                {t("section3.left.title")}
              </h5>
              <p className="lg:text-xl opacity-80">
                {t("section3.left.description")}
              </p>
            </div>
          </div>

          {/* Right Card */}
          <div className="basis-1/2">
            <div className="bg-white shadow dark:bg-zinc-900 rounded-2xl p-10 flex flex-col gap-6 lg:h-[692px] xl:h-[528px] 2xl:h-[472px]">
              <div className="dark:block hidden">
                <UserSquareIcon />
              </div>
              <div className="dark:hidden block">
                <UserSquareIconDark />
              </div>
              <h5 className="text-2xl lg:text-4xl">
                {t("section3.right.title")}
              </h5>
              <p className="lg:text-xl opacity-80">
                {t("section3.right.description")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AboutSections;
